import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { ENDPOINT } from '../utils/Endpoints';

/**
 * PageViewTracker - Automatically tracks page views when user navigates
 * Runs silently in background without affecting UI
 */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');

    // Only track if user is authenticated
    if (!userId || !token) {
      return;
    }

    // Don't track certain routes (like login, signup, etc.)
    const noTrackRoutes = ['/login', '/signup', '/parent/login'];
    if (noTrackRoutes.includes(location.pathname)) {
      return;
    }

    const storageKey = 'courseecho:last-pageview';
    const lastRaw = sessionStorage.getItem(storageKey);
    if (lastRaw) {
      try {
        const last = JSON.parse(lastRaw) as { pathname?: string; at?: number };
        if (last.pathname === location.pathname && typeof last.at === 'number' && (Date.now() - last.at) < 60000) {
          return;
        }
      } catch {
        // ignore malformed cache
      }
    }

    sessionStorage.setItem(storageKey, JSON.stringify({ pathname: location.pathname, at: Date.now() }));

    // Track page view (async, don't wait for it)
    trackPageView(userId, token, location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

const trackPageView = async (userId: string, token: string, pathname: string) => {
  try {
    // Extract page title
    const pageTitle = document.title || pathname;

    await axios.post(
      `${ENDPOINT}/activity/track/page-view`,
      {
        user_id: parseInt(userId),
        page_url: pathname,
        page_title: pageTitle,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(`Page view tracked: ${pathname}`);
  } catch (error) {
    console.error('Error tracking page view:', error);
    // Silently fail - don't disrupt user experience
  }
};

export default PageViewTracker;
